import { render } from "./TaxpayerDetailsModal.vue?vue&type=template&id=d926cd1a&scoped=true"
import script from "./TaxpayerDetailsModal.vue?vue&type=script&lang=js"
export * from "./TaxpayerDetailsModal.vue?vue&type=script&lang=js"

import "./TaxpayerDetailsModal.vue?vue&type=style&index=0&id=d926cd1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d926cd1a"]])

export default __exports__